<template>
  <div class="product-info x-tablelist-view" data-automation="productInfo">
    <div class="product-info-header">
      <div class="product-header-title">
        {{ $t('HT.productAll.info') }}
        <ux-button text icon="ux_icon_edit" @click="showEdit"></ux-button>
      </div>

      <div class="product-header-box">
        <div
          class="product-header-item"
          v-for="item in header"
          :key="item.prop"
          :style="[{ width: item.width }]"
        >
          <span class="product-header-lable">{{ item.label }}</span>
          <template v-if="item.isType">
            <span class="product-header-data">{{
              $opt.switchStr(formData.type, $opt[item.prop])
            }}</span>
          </template>
          <template v-else>
            <span class="product-header-data">{{ formData[item.prop] }}</span>
          </template>
        </div>
      </div>
    </div>

    <!-- tab栏 -->
    <div class="product-info-tabbox" :class="'product-info-tabbox-' + currentTab">
      <div
        :class="['product-info-tab', { 'product-info-tab-active': currentTab === item.name }]"
        v-for="item in tabList"
        :key="item.name"
        @click="tabClick(item)"
      >
        {{ item.label }}
      </div>
    </div>

    <div class="info-content x-padding-x">
      <div class="product-table-header">
        <div class="product-table-header-left">
          <!-- 定价 -->
          <template v-if="isPricingTab">
            <add-rule-pop
              v-if="hasModule20"
              icon="ux_icon_plus"
              :content="$t('HT.add')"
              :disabled="tableData.totalSize >= 10"
              @confirm="addRule"
            ></add-rule-pop>
          </template>
          <!-- API -->
          <template v-else>
            <ux-button type="primary" v-if="hasModule20" icon="ux_icon_plus" @click="showAdd">
              {{ $t('HT.router.addApi') }}</ux-button
            >
          </template>
          <span class="product-info-total">{{
            $t('HT.orderOverview.total', { total: tableData.totalSize })
          }}</span>
        </div>

        <div class="product-table-header-right" v-if="!isPricingTab">
          <ux-button text icon="ux_icon_clouddownload" @click="generateApi">
            {{ $t('HT.productAll.createdApi') }}</ux-button
          >
        </div>
      </div>

      <!-- 定价 -->
      <ux-table
        class="product-info-table"
        layout="total, sizes, prev, pager, next"
        :show-page="false"
        :data="tableData.list"
        :total="tableData.totalSize"
        :size.sync="searchParams.size"
        :page.sync="searchParams.page"
        :emptyText="$t('HT.nodata')"
        :columns="currentColumns"
        @changePage="changePage"
        @changeSize="changeSize"
      ></ux-table>
    </div>
  </div>
</template>

<script>
import addApiItem from './template/addApi';
import addProduct from './template/addProduct';
import addRulePop from './template/addRulePop';
import delRulePop from './template/delRulePop';

export default {
  components: {
    addApiItem,
    addProduct,
    addRulePop,
    delRulePop
  },
  data() {
    return {
      currentTab: 'pricing',
      // 详情
      formData: {},
      ruleTypeOptions: this.$opt.ruleType,
      tabList: [
        {
          label: this.$t('HT.productAll.pricing'),
          name: 'pricing'
        },
        {
          label: this.$t('HT.productAll.api'),
          name: 'api'
        }
      ],
      header: [
        { label: this.$t('HT.unbindApi.name'), prop: 'name', width: '33%' },
        { label: this.$t('HT.createdTime'), prop: 'created_date', width: '33%' },
        { label: this.$t('HT.productAll.type'), prop: 'productType', width: '33%', isType: true },
        { label: this.$t('HT.addProduct.remark'), prop: 'remark', width: '100%' }
      ],
      id: this.$route.query.id, // 产品id
      // api表的数据
      tableData: {
        totalSize: 0,
        list: []
      },
      searchParams: {
        size: 10,
        page: 1
      },
      // 是否显示分页
      // showPage: false,
      columns1: [
        // 表格项
        {
          label: this.$t('HT.productAll.index'),
          type: 'index',
          width: 150,
          index: (val) => {
            const { page, size } = this.searchParams;
            return (page - 1) * size + val + 1;
          }
        },
        {
          label: 'API',
          tooltip: true,
          prop: 'name'
        },
        {
          label: this.$t('HT.upgrade.type'),
          tooltip: true,
          prop: 'type'
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(20),
          render: (h, params) => {
            return h('span', {}, [
              h(
                'ux-button',
                {
                  props: {
                    type: 'primary',
                    text: true
                  },
                  attrs: {
                    style: 'margin-right: 10px'
                  },
                  on: {
                    click: () => {
                      this.unbund(params);
                    }
                  }
                },
                this.$t('HT.unbind')
              ),
              h(
                'ux-button',
                {
                  props: {
                    type: 'danger',
                    text: true
                  },
                  attrs: {
                    style: 'margin-right: 10px'
                  },
                  on: {
                    click: () => {
                      console.log('HT.delete');
                    }
                  }
                },
                this.$t('HT.delete')
              )
            ]);
          }
        }
      ],
      pricingColumns: [
        {
          label: this.$t('HT.productAll.index'),
          type: 'index',
          align: 'left',
          width: 150,
          index: (val) => {
            const { page, size } = this.searchParams;
            return (page - 1) * size + val + 1;
          }
        },
        {
          label: this.$t('HT.productAll.type1'),
          tooltip: true,
          render: (h, params) => {
            const val =
              this.ruleTypeOptions.find((item) => item.value === params.type)?.value || '总额计费';
            return h('span', {}, val);
          }
        },
        {
          label: this.$t('HT.productAll.count'),
          tooltip: true,
          prop: 'count'
        },
        {
          label: this.$t('HT.addRulePop.money'),
          tooltip: true,
          align: 'left',
          prop: 'money'
        },
        {
          label: this.$t('HT.operation'),
          align: 'left',
          hidden: !this.$hasModule(20),
          render: (h, params) => {
            return h('span', {}, [
              h(
                addRulePop,
                {
                  props: {
                    content: this.$t('HT.edit'),
                    text: true,
                    placement: 'left',
                    formData: {
                      type: params.type, // 计费方式
                      count: String(params.count / 10000), // 配额量
                      money: String(params.money) // 价格
                    }
                  },
                  attrs: {
                    style: 'margin-right: 10px'
                  },
                  on: {
                    confirm: (data) => {
                      const postData = {
                        id: params.id,
                        ...data
                      };
                      this.editRule(postData);
                    }
                  }
                },
                ''
              ),
              h(delRulePop, {
                props: {
                  title: this.$t('HT.delete2'),
                  text: this.$t('HT.delete'),
                  placement: 'bottom'
                },
                on: {
                  'on-confirm': () => {
                    this.delRule(params.id);
                  }
                }
              })
            ]);
          }
        }
      ]
    };
  },

  created() {
    this.getTabName();
    this.getInfoList(this.id);
    this.getInfo(this.id);
  },
  mounted() {
    // document.querySelector('.product-info-table .ux-pagination')?.classList.remove('is-background');
  },
  computed: {
    // 定价页
    isPricingTab() {
      return this.currentTab === 'pricing';
    },
    currentColumns() {
      return this.isPricingTab ? this.pricingColumns : this.columns1;
    },

    // 权限?
    hasModule20() {
      return this.$hasModule(20);
    }
  },
  methods: {
    getTabName() {
      const tabIdx = this.$route.query.tab || 0;
      this.currentTab = this.tabList[tabIdx].name;
    },

    /**
     * @description: row上移
     * @param {Object} : params 表的一条数据
     */
    tabUp(params) {
      const { id, type, api_or_group_id, order, index } = params;
      // 第一个 跳出
      if (index == 0) {
        return;
      }
      this.$api.product
        .sortList({
          aog_arr: {
            id,
            type,
            api_or_group_id,
            order
          },
          status: 1
        })
        .then((res) => {
          if (res.code === 10000) {
            this.getInfoList(this.formData.id);
          }
        });
    },
    /**
     * @description: row下移
     * @param {Object} :params 表的一条数据
     */
    tabDown(params) {
      const { id, type, api_or_group_id, order, index } = params;
      // 最后一个 跳出
      if (index == this.tableData.totalSize - 1) {
        return;
      }
      this.$api.product
        .sortList({
          aog_arr: {
            id,
            type,
            api_or_group_id,
            order
          },
          status: 0
        })
        .then((res) => {
          if (res.code === 10000) {
            this.getInfoList(this.formData.id);
          }
        });
    },
    /**
     * @description: 解绑
     * @param {Object} :表的一条数据
     */
    unbund(params) {
      const { type, id, order } = params;
      const title = this.$t('HT.unbind');
      const content = this.$t('HT.productAll.unbind.content');
      this.$uxModal.show({
        title,
        content,
        type: 'warning',
        confirm: () => {
          this.$api.product
            .unbind(this.formData.id, {
              aog_arr: [
                {
                  type,
                  id,
                  order
                }
              ]
            })
            .then((res) => {
              if (res.code === 10000) {
                this.$uxModal.hide();
                this.$uxMessage.success(this.$t('HT.addApi.unbindSuccess'));
                this.getInfoList(this.formData.id);
              }
            });
        }
      });
    },
    generateApi() {
      this.$router.push({
        name: 'generateApi',
        query: {
          id: this.formData.id
        }
      });
    },
    /**
     * 获取基本信息
     */
    getInfo(params) {
      this.$uxLoading.show();
      this.$api.product.getInfo(params).then((res) => {
        if (res.code == 10000) {
          this.formData = res.data;
        }
      });
    },
    /**
     * 管理 ->产品明细页面数据
     * @param {Object} params 表单参数
     */
    getInfoList(params) {
      this.$uxLoading.show();
      this.tableData = {
        totalSize: 0,
        list: []
      };

      const apiName = this.isPricingTab ? 'getRuleList' : 'getInfoList';
      this.$api.product[apiName](params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size || res.data.length,
            list: res.data
          };
        }
      });
    },
    /**
     * 产品绑定API/API分组
     */
    setApigroup(data) {
      this.$api.product
        .setApigroup(this.formData.id, {
          aog_arr: data
        })
        .then((res) => {
          if (res.code === 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.bindSuccess'));
            this.getInfoList(this.formData.id);
          }
        });
    },

    /**
     * 编辑
     */
    showEdit() {
      const title = this.$t('HT.edit');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addProduct, {
            props: { data: this.formData },
            on: {}
          });
        },
        confirm: (data) => {
          this.putList(data);
        }
      });
    },
    /**
     * 新增-弹窗
     */
    showAdd() {
      const title = this.$t('HT.router.addApi');
      this.$uxModal.show({
        title,
        hideBtn: true,
        content: (h) => {
          return h(addApiItem, {
            props: {
              // 将已有的Api分组 ->添加API/分组 ->渲染列表
              apiData: this.tableData.list
            },
            on: {
              confirm: (data) => {
                this.setApigroup(data);
              }
            }
          });
        }
      });
    },

    /**
     * 修改列表
     * @param {Number} id 唯一标识
     * @param {Object} params 表单提交参数
     */
    putList(params) {
      this.$uxLoading.show();
      this.$api.product.putList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
          this.getInfo(this.id);
        }
      });
    },

    /**
     * 删除列表
     */
    delList() {
      this.$uxLoading.show();
      const params = this.formData;

      if (params.published == false) {
        this.$api.product.delList(params.id).then((res) => {
          if (res.code == 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
            this.$router.push({
              name: 'productList'
            });
          }
        });
      } else {
        this.$uxModal.hide();
        this.$uxMessage.error(this.$t('HT.addApi.delError'));
      }
    },

    /**
     * 新增规格
     */
    addRule(data) {
      const params = {
        product_id: this.formData.id,
        ...data
      };
      this.$uxLoading.show();
      this.$api.product.addRule(params).then((res) => {
        if (res.code == 10000) {
          this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
          this.getInfoList(this.id);
        }
      });
    },

    /**
     * 编辑规格
     */
    editRule(data) {
      const params = {
        product_id: this.formData.id,
        ...data
      };
      this.$uxLoading.show();
      this.$api.product.editRule(params).then((res) => {
        if (res.code == 10000) {
          this.$uxMessage.success(this.$t('HT.addApi.operateSuccess'));
          this.getInfoList(this.id);
        }
      });
    },

    /**
     * 删除规格
     */
    delRule(id) {
      const params = {
        productId: this.formData.id,
        id
      };
      this.$uxLoading.show();
      this.$api.product.delRule(params).then((res) => {
        if (res.code == 10000) {
          this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
          this.getInfoList(this.id);
        }
      });
    },

    /**
     * 切换登录方式
     * @param {Object} params 查询对象
     */
    tabClick(tab) {
      if (this.currentTab === tab.name) {
        return;
      }
      this.currentTab = tab.name;
      this.$nextTick(() => {
        // document
        //   .querySelector('.product-info-table .ux-pagination')
        //   ?.classList.remove('is-background');
        this.searchParams.page = 1;
        this.getInfoList(this.formData.id);
      });
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.searchParams.size = size;
      this.searchParams.page = 1;
      this.getInfoList(this.formData.id);
    },

    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.searchParams.page = page;
      this.getInfoList(this.formData.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.x-tablelist-view.product-info {
  height: 100%;
  margin: 0;
  background: none;
  border: none;
  padding: 20px 40px 0 20px;

  .product-info-header {
    padding: 32px 40px;
    margin-bottom: 20px;
    border-radius: 8px;
    background: #fff;

    .product-header-title {
      width: 100%;
      font-weight: 600;
      color: $color-title;
      line-height: 20px;
      height: 44px;
      font-size: 14px;
    }

    .product-header-box {
      margin-bottom: 8px;
    }

    .product-header-item,
    .product-header-lable,
    .product-header-data {
      display: inline-block;
      vertical-align: top;
      font-size: 14px;
    }

    .product-header-item {
      display: inline-block;
      vertical-align: top;
      font-size: 0;
      padding-bottom: 20px;
    }

    .product-header-lable {
      color: $color-text;
      width: 120px;
    }

    .product-header-data {
      color: $color-title;
      width: calc(100% - 122px);
    }

    .product-header-btns .ux-button {
      padding-left: 20px;
      padding-right: 20px;
      margin-right: 8px;
    }
  }

  .product-info-tabbox {
    position: relative;
    width: 100%;
    text-align: left;
    height: 72px;
    flex-shrink: 0;

    &::before {
      content: '';
      position: absolute;
      top: 44px;
      left: 116px;
      width: 116px;
      height: 4px;
      background: $color-primary;
      transition: all 0.3s;
    }

    &.product-info-tabbox-pricing::before {
      left: 0;
    }

    &.product-info-tabbox-api::before {
      left: 116px;
    }

    .product-info-tab {
      display: inline-block;
      vertical-align: top;
      width: 116px;
      height: 48px;
      font-size: 14px;
      font-weight: 400;
      color: $color-text;
      line-height: 48px;
      text-align: center;
      cursor: pointer;

      &.product-info-tab-active {
        color: $color-title;
        font-weight: 600;
      }
    }
  }
  .info-content {
    padding-bottom: 20px;
  }
  .product-table-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    justify-content: space-between;

    .product-info-total {
      color: $color-text-secondary;
      height: 20px;
      line-height: 20px;
      margin-left: 20px;
    }

    .product-table-header-right {
      .ux-button {
        margin-left: 20px;
      }
    }
  }

  ::v-deep .product-info-table .ux-pagination {
    text-align: right;
    padding: 20px 0 32px;

    .btn-next,
    .btn-prev {
      height: 32px;
      background: transparent;
    }

    .el-pager {
      .el-icon-more,
      .number,
      .btn-quicknext:hover {
        height: 32px;
        line-height: 32px;
        background: transparent;
      }
    }

    .el-pagination__sizes .el-select .el-input {
      .el-input__inner {
        border: none;
        background: transparent;
      }
    }
  }
}
</style>
